export const HIGHLIGHT_DURATION_MS = 2_000;

const GROUP_WINDOW_MINUTES = 5;
const SECONDS_PER_MINUTE = 60;
const MS_PER_SECOND = 1_000;

export const GROUP_WINDOW_MS = GROUP_WINDOW_MINUTES * SECONDS_PER_MINUTE * MS_PER_SECOND;

export const EMPTY_MEMBERS = [];

export const EMPTY_PINNED_IDS = [];
